class Showroom {
  constructor(el) {
    this.$el = el;
    this.$items = Array.from(this.$el.querySelectorAll('.project-item'));
    this.$filters = Array.from(this.$el.querySelectorAll('.showroom-filters-list .filter'));
    this.onResize = this.onResize.bind(this);

    this.observer = new ResizeObserver(this.onResize);
    this.observer.observe(this.$el);
    this.currentFilter = 'All';

    this.$filters.forEach($filter => {
      $filter.addEventListener('click', () => {
        this.filterBy($filter.dataset.filter);
      });
    });
    const params = new URLSearchParams(window.location.search);
    const initialFilter = params.get('filter');
    if (initialFilter) {
      this.filterBy(initialFilter);
      // opcional: que baje hasta el showroom
      this.$el.scrollIntoView({ behavior: 'smooth' });
    }
  }
  onResize() {
    let tallest = 0;
    this.$items.forEach(item => {
      const $info = item.querySelector('.project-item-info');
      $info.style.height = 'auto';
      const height = $info.getBoundingClientRect().height;
      tallest = Math.max(tallest, height);
    });
    this.$items.forEach(item => {
      const $info = item.querySelector('.project-item-info');
      $info.style.height = `${tallest}px`;
    });
  }
  filterBy(filter) {
    if (this.currentFilter === filter) this.currentFilter = 'All';
    else this.currentFilter = filter;
    this.$filters.forEach($filter => {
      $filter.classList.toggle('active', $filter.dataset.filter === this.currentFilter);
    });
    this.$items.forEach($item => {
      const tags = Array.from($item.querySelectorAll('.project-item-tags span'))
      $item.classList.toggle('hidden', !tags.some($tag => $tag.innerText === this.currentFilter) && this.currentFilter !== 'All');
    });
  }
}